import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import CertificateProductSelection from "../../components/Certificates/CertificateProductSelection";
import { useService } from "../../context/ServiceContext";

function CertificatesEdit({ history, match }) {
  const [existingCertificate, setExistingCertificate] = useState(null);
  const { keyCompany, series, language, documentClass, documentReference } = match.params;
  const { certificateExistingProvider } = useService();

  useEffect(() => {
    async function getData() {
      try {
        const certificateData = await certificateExistingProvider.get({
          keyCompany,
          series,
          language,
          documentClass,
          documentReference,
        });
        setExistingCertificate(certificateData);
      } catch (error) {
      } finally {
      }
    }
    getData();
  }, []);

  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="certificates.title" defaultMessage="Certificates" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardBody>
                {existingCertificate && (
                  <>
                    <CertificateProductSelection history={history} existingCertificate={existingCertificate}></CertificateProductSelection>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export function ExistingCertificateSummary({ data }) {
  return (
    <Card>
      <CardBody>
        <h2>
          <FormattedMessage id="certificates.certificate_summary" defaultMessage="Certificate summary" />
        </h2>
        <span className="mr-3">
          <b>
            <FormattedMessage id="app.series" defaultMessage="Series" />
          </b>{" "}
          {data.seriesShortName}
        </span>
        <span className="mr-3">
          <b>
            <FormattedMessage id="certificates.type_of_document" defaultMessage="Type of document" />
          </b>{" "}
          {data.typeOfDocument}
        </span>
        <span className="mr-3">
          <b>
            <FormattedMessage id="certificates.document_class" defaultMessage="Document Class" />
          </b>{" "}
          {data.documentClass}
        </span>
        <span className="mr-3">
          <b>
            <FormattedMessage id="certificates.document_reference" defaultMessage="Reference" />
          </b>{" "}
          {data.documentReference}
        </span>
      </CardBody>
    </Card>
  );
}

export default CertificatesEdit;
